export default __webpack_public_path__ + "static/media/kisspng-2018.2799d540.webp";